import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { NavigationService } from "../../../navigation/navigation.service";

/**
 * Generated class for the CompanyResourcesNavigationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "company-resources-navigation",
  templateUrl: "company-resources-navigation.html",
})
export class CompanyResourcesNavigation {
  @Output()
  navigated = new EventEmitter<string>();
  private _providersActive: boolean = false;
  private _nonProvidersActive: boolean = false;
  private _volunteersActive: boolean = false;
  private _backOfficeActive: boolean = false;
  private _activityLogActive: boolean = false;
  private _reportsActive: boolean = false;

  private _hasEmployeeAccess: boolean = false;
  private _hasProviderAccess: boolean = false;
  private _hasVolunteerAccess: boolean = false;
  private _hasBackOfficeAccess: boolean = false;

  private _nonProvidersEnabled: boolean = false;
  private _volunteersEnabled: boolean = false;
  private _backOfficeEnabled: boolean = false;
  private _activityLogEnabled: boolean = false;
  private _teamsEnabled: boolean = true;
  private _reportsEnabled: boolean = true;

  constructor(
    public navCtrl: NavController,
    private navigationService: NavigationService,
    public navParams: NavParams
  ) {}

  ionViewDidLoad() {}

  redirectPage(entity: string) {
    if (entity === "providers") {
      this.navigationService.goToInternalPage(
        "ProfessionalProvidersListPage",
        {}
      );
    } else if (entity === "non-providers") {
      this.navigationService.goToInternalPage("NonProviderClinicians", {});
    } else if (entity === "volunteers") {
      this.navigationService.goToInternalPage("CompanyVolunteersPage", {});
    } else if (entity === "backOffice") {
      this.navigationService.goToInternalPage("BackOfficePage", {});
    } else if (entity === "activityLog") {
      this.navigationService.goToInternalPage("ActivityLogPage", {});
    } else if (entity === "teams") {
      this.navigationService.goToInternalPage("CompanyTeamsPage", {});
    } else if (entity === "reports") {
      this.navigationService.goToInternalPage("ResourceReportsPage", {});
    }
  }

  @Input()
  set hasEmployeeAccess(value: boolean) {
    this._hasEmployeeAccess = value;
  }

  @Input()
  set volunteersEnabled(value: boolean) {
    this._volunteersEnabled = value;
  }

  @Input()
  set nonProviderCliniciansEnabled(value: boolean) {
    this._nonProvidersEnabled = value;
  }

  @Input()
  set backOfficeEnabled(value: boolean) {
    this._backOfficeEnabled = value;
  }

  @Input()
  set activityLogEnabled(value: boolean) {
    this._activityLogEnabled = value;
  }

  @Input()
  set teamsEnabled(value: boolean) {
    this._teamsEnabled = value;
  }

  @Input()
  set providersActive(value: boolean) {
    if (value) {
      this._activityLogActive = false;
      this._backOfficeActive = false;
      this._nonProvidersActive = false;
      this._volunteersActive = false;
    }
    this._providersActive = value;
  }

  @Input()
  set volunteersActive(value: boolean) {
    if (value) {
      this._activityLogActive = !value;
      this._backOfficeActive = !value;
      this._nonProvidersActive = !value;
      this._providersActive = !value;
    }
    this._volunteersActive = value;
  }

  @Input()
  set nonProvidersActive(value: boolean) {
    if (value) {
      this._activityLogActive = !value;
      this._backOfficeActive = !value;
      this._providersActive = !value;
      this._volunteersActive = !value;
    }
    this._nonProvidersActive = value;
  }

  @Input()
  set reportsActive(value: boolean) {
    if (value) {
      this._activityLogActive = !value;
      this._nonProvidersActive = !value;
      this._providersActive = !value;
      this._volunteersActive = !value;
      this._backOfficeActive = !value;
    }
    this._reportsActive = value;
  }

  @Input()
  set backOfficeActive(value: boolean) {
    if (value) {
      this._activityLogActive = !value;
      this._nonProvidersActive = !value;
      this._providersActive = !value;
      this._volunteersActive = !value;
    }
    this._backOfficeActive = value;
  }

  @Input()
  set activityLogActive(value: boolean) {
    if (value) {
      this._providersActive = !value;
      this._volunteersActive = !value;
      this._nonProvidersActive = !value;
      this._backOfficeActive = !value;
    }
    this._activityLogActive = value;
  }

  @Input()
  set hasProviderAccess(value: boolean) {
    this._hasProviderAccess = value;
  }

  @Input()
  set hasVolunteerAccess(value: boolean) {
    this._hasVolunteerAccess = value;
  }

  @Input()
  set hasBackOfficeAccess(value: boolean) {
    this._hasBackOfficeAccess = value;
  }

  @Input() set reportsEnabled(value: boolean) {
    this._reportsEnabled = value;
  }

  get reportsEnabled(): boolean {
    return this._reportsEnabled;
  }

  get hasProviderAccess(): boolean {
    return this._hasProviderAccess;
  }

  get hasEmployeeAccess(): boolean {
    return this._hasEmployeeAccess;
  }

  get hasVolunteerAccess(): boolean {
    return this._hasVolunteerAccess;
  }

  get hasBackOfficeAccess(): boolean {
    return this._hasBackOfficeAccess;
  }

  get providersActive(): boolean {
    return this._providersActive;
  }

  get nonProvidersActive(): boolean {
    return this._nonProvidersActive;
  }

  get reportsActive(): boolean {
    return this._reportsActive;
  }

  get volunteersActive(): boolean {
    return this._volunteersActive;
  }

  get backOfficeActive(): boolean {
    return this._backOfficeActive;
  }

  get activityLogActive(): boolean {
    return this._activityLogActive;
  }

  get nonProviderCliniciansEnabled(): boolean {
    return this._nonProvidersEnabled;
  }

  get volunteersEnabled(): boolean {
    return this._volunteersEnabled;
  }

  get backOfficeEnabled(): boolean {
    return this._backOfficeEnabled;
  }

  get activityLogEnabled(): boolean {
    return this._activityLogEnabled;
  }

  get teamsEnabled(): boolean {
    return this._teamsEnabled;
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-resources/company-resources-navigation/company-resources-navigation.ts